<template>
  <div class="loading-screen">
    <div class="logo-container">
      <svg viewBox="0 0 120 120" class="logo-svg" xmlns="http://www.w3.org/2000/svg">
        <!-- Track del anillo exterior -->
        <circle cx="60" cy="60" r="50" fill="none" stroke="#e2e8f4" stroke-width="2" />

        <!-- Arco giratorio -->
        <circle
          cx="60" cy="60" r="50"
          fill="none"
          stroke="#1B3A6B"
          stroke-width="2.5"
          stroke-linecap="round"
          class="spin-ring"
        />

        <!-- Logo: letra C -->
        <path
          d="M 83 37 A 33 33 0 1 0 83 83"
          fill="none"
          stroke="#1B3A6B"
          stroke-width="18"
          stroke-linecap="round"
          class="c-path"
        />

        <!-- Punto naranja (ligeramente a la derecha del centro) -->
        <circle cx="59" cy="60" r="15" fill="#FF6600" class="orange-dot" />
      </svg>
    </div>

    <div class="loading-text">
      <span class="text-label">{{ text }}</span>
      <span class="dot d1">.</span>
      <span class="dot d2">.</span>
      <span class="dot d3">.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseLoading",
  props: {
    text: {
      type: String,
      default: "Cargando"
    }
  }
};
</script>

<style scoped>
.loading-screen {
  position: absolute;
  inset: 0;
  background: linear-gradient(160deg, #ffffff 0%, #eef2ff 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  gap: 36px;
  animation: fadeIn 0.3s ease-out;
}

.logo-svg {
  width: 160px;
  height: 160px;
  filter: drop-shadow(0 8px 28px rgba(27, 58, 107, 0.18));
}

/* Anillo exterior giratorio */
.spin-ring {
  stroke-dasharray: 55 259;
  transform-origin: 60px 60px;
  animation: spin 2.2s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* C se dibuja sola */
.c-path {
  stroke-dasharray: 156;
  stroke-dashoffset: 156;
  animation: drawC 1.4s cubic-bezier(0.4, 0, 0.2, 1) 0.2s forwards;
}

@keyframes drawC {
  to { stroke-dashoffset: 0; }
}

/* Punto naranja aparece con rebote y luego pulsa */
.orange-dot {
  opacity: 0;
  transform-origin: 59px 60px; /* centrado en cx/cy del círculo */
  animation:
    dotPop   0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 1.3s forwards,
    dotPulse 2s   ease-in-out                         2s   infinite;
}

@keyframes dotPop {
  from { transform: scale(0); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}

@keyframes dotPulse {
  0%, 100% { transform: scale(1);    opacity: 1;    }
  50%      { transform: scale(1.28); opacity: 0.82; }
}

/* Texto de carga */
.loading-text {
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #4a5568;
  letter-spacing: 0.6px;
  animation: fadeIn 0.5s ease-out 0.5s both;
}

.dot {
  opacity: 0;
  animation: blink 1.4s ease-in-out infinite;
}
.d1 { animation-delay: 0.3s; }
.d2 { animation-delay: 0.6s; }
.d3 { animation-delay: 0.9s; }

@keyframes blink {
  0%, 100% { opacity: 0; }
  50%      { opacity: 1; }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0);    }
}
</style>
